<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'common.stories' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="re-hub-scroll re-tab-hub">
  <div class="re-tab-hub__shell">
    <h1 class="re-visually-hidden">{{ 'common.stories' | translate }}</h1>
    @if (storiesService.loading()) {
    <div class="re-story-grid" aria-busy="true" [attr.aria-label]="'stories.list.loadingAria' | translate">
      @for (item of [0, 1, 2]; track item) {
      <div class="re-story-card re-story-card--skeleton">
        <ion-skeleton-text class="re-story-card__cover-skeleton" animated></ion-skeleton-text>
        <div class="re-story-card__body">
          <ion-skeleton-text style="height: 1.1rem; width: 68%" animated></ion-skeleton-text>
          <ion-skeleton-text style="height: 0.8rem; width: 48%" animated></ion-skeleton-text>
        </div>
      </div>
      }
    </div>
    } @else if (storiesService.error()) {
    <div class="stories-empty stories-state-card re-empty-state" role="alert">
      <div class="stories-empty__icon re-empty-state__icon" aria-hidden="true">
        <ion-icon name="alert-circle-outline"></ion-icon>
      </div>
      <p class="stories-empty__title re-empty-state__title">{{ 'common.loadError' | translate }}</p>
      <ion-button class="stories-empty__cta re-empty-state__action" shape="round" (click)="storiesService.getStories()">
        {{ 'common.retry' | translate }}
      </ion-button>
    </div>
    } @else {
    @if (storiesService.stories().length > 0) {
    <div class="re-story-grid">
      @for (story of storiesService.stories(); track story.id) {
      @let rooms = roomsCount(story);
      @let participants = participantsCount(story);
      <a class="re-story-card" [routerLink]="['./', story.id]">
        <span class="re-story-card__cover">
          <re-story-sigil [storyId]="story.id"></re-story-sigil>
          @if (story.ai_mode === 'AI') {
          <span class="re-badge re-badge--ai re-story-card__badge">{{ 'stories.list.aiBadge' | translate }}</span>
          }
        </span>
        <span class="re-story-card__body">
          <span class="re-story-card__heading">
            <span class="re-story-card__title">{{ story.name }}</span>
          </span>
          <span class="re-story-card__meta">
            {{ roomLabelKey(rooms) | translate: { count: rooms } }}
            <span aria-hidden="true">·</span>
            {{ participantLabelKey(participants) | translate: { count: participants } }}
          </span>
        </span>
      </a>
      }
    </div>
    } @else {
    <div class="stories-empty stories-state-card re-empty-state">
      <div class="stories-empty__icon re-empty-state__icon" aria-hidden="true">
        <ion-icon name="book-outline"></ion-icon>
      </div>
      <p class="stories-empty__title re-empty-state__title">{{ 'stories.list.empty' | translate }}</p>
      <p class="stories-empty__hint re-empty-state__description">{{ 'stories.list.emptyHint' | translate }}</p>
      <ion-button class="stories-empty__cta re-empty-state__action" routerLink="/stories/create-story" shape="round">
        {{ 'stories.list.createCta' | translate }}
      </ion-button>
    </div>
    }
    }

  </div>
  <ion-fab slot="fixed" vertical="bottom" horizontal="end">
    <ion-fab-button routerLink="/stories/create-story" [attr.aria-label]="'stories.create.title' | translate">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
